export const ADD_TRACKED_EXCHANGES = "ADD_TRACKED_EXCHANGES";
export const REMOVE_TRACKED_EXCHANGE = "REMOVE_TRACKED_EXCHANGE";